<script setup lang="ts">
import RlSearchCard from '@/components/common/RlSearchCard.vue'
import type { IPolicy } from '@/types/asicw/policies'
import { computed } from 'vue'

const props = defineProps<{ policy: IPolicy }>()

const detailItems = computed(() => [
  { header: 'Model Family', value: props.policy.insured_miner.model_family },
  { header: 'SN', value: props.policy.insured_miner.sn },
])
</script>

<template>
  <rl-search-card :detail-items="detailItems">
    <template #header>
      <span>Policy #{{ props.policy.number }}</span>
      <el-tag>{{ props.policy.customer.name }}</el-tag>
    </template>
  </rl-search-card>
</template>
